import { render, staticRenderFns } from "./shopSearchKeywords.vue?vue&type=template&id=11c34185&"
import script from "./shopSearchKeywords.vue?vue&type=script&lang=js&"
export * from "./shopSearchKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports